"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLockedIntegrationTextKey = exports.getIsStripeInstalled = exports.getIsSalesforceInstalled = exports.getFetchInstalledRequestStatus = exports.getIntegrationsState = void 0;

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _constants = require("./constants");

var _selectors = require("settings-ui-sdk/Ecommerce/selectors");

var getIntegrationsState = function getIntegrationsState(state) {
  return state.modules.ecommerce.integrations;
};

exports.getIntegrationsState = getIntegrationsState;
var getFetchInstalledRequestStatus = (0, _getRequestStatus.default)(_actions.IntegrationsActionTypes.FETCH_INSTALLED_INTEGRATIONS);
exports.getFetchInstalledRequestStatus = getFetchInstalledRequestStatus;
var getInstalledIntegrations = (0, _reselect.createSelector)([getIntegrationsState], function (integrationsState) {
  return integrationsState.get('integrations');
});
var getIsSalesforceInstalled = (0, _reselect.createSelector)([getInstalledIntegrations], function (integrations) {
  return integrations.some(function (integration) {
    return integration.id === (0, _constants.getSalesforceAppId)();
  });
});
exports.getIsSalesforceInstalled = getIsSalesforceInstalled;
var getIsStripeInstalled = (0, _reselect.createSelector)([getInstalledIntegrations], function (integrations) {
  return integrations.some(function (integration) {
    return integration.id === (0, _constants.getStripeAppId)();
  });
});
exports.getIsStripeInstalled = getIsStripeInstalled;
var getLockedIntegrationTextKey = (0, _reselect.createSelector)([getIsSalesforceInstalled, _selectors.getIsEcommerceIntegrationConnected], function (isSalesforceInstalled, isEcommBridgeAppInstalled) {
  if (isSalesforceInstalled) {
    return 'salesforceInstalled';
  } else if (isEcommBridgeAppInstalled) {
    return 'ecommBridgeAppInstalled';
  }

  return null;
});
exports.getLockedIntegrationTextKey = getLockedIntegrationTextKey;